@if (filters$ | async; as filters) {
    @if (filters.length) {
        <h2
            class="reset-filter-container__title"
        >
            Ausgewählte Filter
        </h2>
    }
    @if (filters.length) {
        <div
            aria-live="polite"
            aria-label="Ausgewählte Filter"
            class="reset-filter-container__banners"
        >
            @for (filter of filters; track filter.key) {
                <ui-filter-banner
                    class="reset-filter-container__banner"
                    [filter]="filter"
                    (click)="resetFilter(filter)"
                    (keydown.enter)="resetFilter(filter)"
                    (keydown.space)="resetFilter(filter)"
                />
            }
        </div>
    }
}
